import { render, staticRenderFns } from "./AuthorizationWindow.vue?vue&type=template&id=7e9b71ce"
import script from "./AuthorizationWindow.vue?vue&type=script&lang=js"
export * from "./AuthorizationWindow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports